export class NavigationToolManager {
    addToMap(map) {
        this.map = map;
    }
    zoomIn() {
        if (typeof this.map === "undefined")
            return;
        this.map.zoomIn();
    }
    zoomOut() {
        if (typeof this.map === "undefined")
            return;
        this.map.zoomOut();
    }
}
